var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.$style.prefix},[_vm._v("power-bi-workspace/")]),_c('span',{class:_vm.$style.prefix},[_vm._v(_vm._s(_vm.workspaceId)+"-")]),_c('span',[_vm._v(_vm._s(_vm.roleNameSuffix))])])}
var staticRenderFns = []

export { render, staticRenderFns }